import { render, staticRenderFns } from "./CoursePhotoUpload.vue?vue&type=template&id=673a406d&scoped=true&lang=pug&"
import script from "./CoursePhotoUpload.vue?vue&type=script&lang=js&"
export * from "./CoursePhotoUpload.vue?vue&type=script&lang=js&"
import style0 from "./CoursePhotoUpload.vue?vue&type=style&index=0&id=673a406d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a406d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
